import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const StopCircleIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/stop-circle"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M2.40002 12.0004C2.40002 6.69846 6.69809 2.40039 12 2.40039C17.302 2.40039 21.6 6.69846 21.6 12.0004C21.6 17.3023 17.302 21.6004 12 21.6004C6.69809 21.6004 2.40002 17.3023 2.40002 12.0004ZM8.40003 9.30039C8.40003 8.80334 8.80297 8.40039 9.30003 8.40039H14.7C15.1971 8.40039 15.6 8.80334 15.6 9.30039V14.7004C15.6 15.1974 15.1971 15.6004 14.7 15.6004H9.30003C8.80297 15.6004 8.40003 15.1974 8.40003 14.7004V9.30039Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default StopCircleIcon;